<h1 mat-dialog-title>
    {{isInstruction ? 'Not able ' : 'We are unable '}} to access your {{device + (isInstruction ? '?' : '')}}
</h1>

<button mat-button class="close" (click)="closeDailog()">
    <span class="material-icons">
        close
    </span>
    Close
</button>

<div mat-dialog-content>
    <div class="container-box">
        <div class="access-modal-content">
            <div class="heading-section">
            </div>
            <div class="access-section-info">
                <div class="access-img">
                    <img src="assets/images/video-conference-icon.png" alt="video conference icon">
                </div>
                <div class="access-info-msg">
                    <h3><span>1</span> Another application could be using your
                        <!-- Boomcaster needs your {{device}} access, see if some other app is using your -->
                        <!-- Skype/Zoom/Hangout or some other video conferencing application is using your -->
                        <div class="access-permission-modal-device" style="display: inline-block;">
                            {{device}}
                        </div>
                    </h3>
                    <p>Please quit any application that could be using your </p>
                    <div class="access-permission-modal-device" style="display: inline-block;">
                        {{device}}</div>
                    like zoom/skype/google hangout etc.
                    <p></p>

                </div>
            </div>

            <div class="access-section-info reverse-info">
                <div class="access-info-msg">
                    <h3><span>2</span>
                        <div class="access-permission-modal-device" style="display: inline-block;">
                        </div> Your browser could be blocking access to {{device}}
                    </h3>

                    <div class="access-permission-modal-device" style="display: inline-block;">
                        <p>Please click on the lock icon in the address bar and allow access to </p> {{device}}.</div>

                    <p></p>
                </div>
                <div class="access-img">
                    <img src="assets/images/allowed-access-icon.png" alt="allowed access icon">
                </div>
            </div>

            <div class="access-section-info">
                <div class="access-img">
                    <img src="assets/images/video_call_icon.png" alt="video call icon">
                </div>
                <div class="access-info-msg">
                    <h3><span>3</span> Your computer might need a restart</h3>
                    <p>Restarting your computer will reset your </p>
                    <div class="access-permission-modal-device" style="display: inline-block;">
                        {{device}}</div>
                    access and will ensure a great hosting experience.
                    <p></p>
                </div>
            </div>

            <div class="access-section-info reverse-info">
                <div class="access-info-msg">
                    <h3><span>4</span> Your browser version is not current</h3>
                    <p>Please ensure that you have latest version of the browser installed. We recommend using the latest version of Chrome browser. If you are using chrome, please click
                        <a href="javascript:void(0)" (click)="checkBrowserLatest()">here</a> to know if you have latest version of the same.</p>
                </div>
                <div class="access-img">
                    <img src="assets/images/browser-icon.png" alt="browser icon">
                </div>
            </div>
        </div>
    </div>
</div>